/* eslint-disable jsx-a11y/label-has-associated-control */
import clsx from 'clsx'
import { HTMLProps } from 'react'

import classes from './index.module.scss'

export const Label = ({ className, ...props }: HTMLProps<HTMLLabelElement>) => (
  <label {...props} className={clsx(classes.root, className)} />
)
